import { Monitor, Smartphone, Tablet } from "lucide-react";

interface DeviceIconProps {
  browser: string;
  os: string;
  deviceType: 'Desktop' | 'Mobile' | 'Tablet';
  className?: string;
}

const DeviceIcon = ({ browser, os, deviceType, className = "w-8 h-8" }: DeviceIconProps) => {
  // Return device type icon
  if (deviceType === 'Mobile') {
    return <Smartphone className={className} />;
  } else if (deviceType === 'Tablet') {
    return <Tablet className={className} />;
  }
  
  return <Monitor className={className} />;
};

export default DeviceIcon;
